import { defineStore } from "pinia";

export const useAppStore = defineStore("AppStore", {
    state: () => {
        return {
            loading: false,
            openReviewSideBar: false,
            showReviewNextButton: false,
            isMobileSidebarVisible: false, // Novo estado para controlar a visibilidade da sidebar no mobile
            currentTab: 3,
            order: {},
            orderType: null,
            orderFormData: {}
        }
    }
})
